import React, { useState } from 'react'
import cn from 'classnames'
import { NavLink, Link, useLocation } from 'react-router-dom'
import styles from './Wallet.module.sass'
import Icon from '../Icon'
import Modal from '../Modal'
import Withdraw from '../Withdraw'
import Transfer from '../Transfer'
import Deposite from 'components/Deposite'
import Convert from 'components/Covvert/index'

const navigation = [
  // {
  //   title: 'Overview',
  //   color: '#23262F',
  //   url: '/dashboard',
  //   separator: true,
  // },
  // {
  //   title: 'Margin',
  //   color: '#9757D7',
  //   url: '/wallet-margin',
  // },
  // {
  //   title: 'Fiat and Spot',
  //   color: '#FFD166',
  //   url: '/fiat-and-spot',
  //   separator: true,
  // },
  // {
  //   title: 'Transfer',
  //   icon: 'arrow-next',
  // },
  // {
  //   title: 'Buy with Fiat',
  //   icon: 'wallet',
  //   url: '/buy-crypto',
  // },
  // {
  //   title: 'Sell for Fiat',
  //   icon: 'sell',
  //   url: '/sell-crypto',
  // },
]

const Wallet = ({ className, children }) => {
  const { pathname } = useLocation()
  const [visibleWithdraw, setVisibleWithdraw] = useState(false)
  const [visibleDeposite, setVisibleDeposite] = useState(false)
  const [visibleTransfer, setVisibleTransfer] = useState(false)
  const [visibleConvert, setVisibleConvert] = useState(false)
  const [visibleMenu, setVisibleMenu] = useState(false)

  const activeItem = navigation.find((x) => pathname.includes(x.url)) || {}

  return (
    <>
      <div className={cn(className, styles.wallet)}>
        
        <div className={styles.wrapper}>
          <div className={styles.btns}>
            {/* <Link
              className={cn('button button-small', styles.button)}
              to="/deposit"
            >
              Deposit
            </Link> */}
            <button
              className={cn('button button-small', styles.button)}
              onClick={() => setVisibleDeposite(!visibleDeposite)}
            >
              Deposit
            </button>
            <button
              className={cn('button-stroke button-small', styles.button)}
              onClick={() => setVisibleWithdraw(!visibleWithdraw)}
            >
              Withdraw
            </button>
            <Link
              className={cn('button-stroke button-small', styles.button)}
              to="/withdraw"
            >
              New Withdraw
            </Link>
            {/* <button
              className={cn('button-stroke button-small', styles.button)}
              onClick={() => setVisibleConvert(!visibleConvert)}
            >
              Convert
            </button> */}
            <button
              className={cn('button-stroke button-small', styles.button)}
              onClick={() => setVisibleTransfer(!visibleTransfer)}
            >
              Transfer
            </button>
          </div>
          <div>
          {children}
          </div>
        </div>
      </div>
      <Modal
        visible={visibleWithdraw}
        onClose={() => setVisibleWithdraw(false)}
        isClosable
      >
        <Withdraw />
      </Modal>
      <Modal
        visible={visibleConvert}
        onClose={() => setVisibleConvert(false)}
        setVisibleConvert={setVisibleConvert}
      >
        <Convert
          setVisibleConvert={setVisibleConvert}
        />
      </Modal>
      <Modal
        visible={visibleDeposite}
        onClose={() => setVisibleDeposite(false)}
        isClosable
      >
        <Deposite setVisibleDeposite={setVisibleDeposite} visibleDeposite={visibleDeposite} />
      </Modal>
      <Modal
        visible={visibleTransfer}
        onClose={() => setVisibleTransfer(false)}
      >
        <Transfer setVisibleTransfer={setVisibleTransfer} />
      </Modal>
    </>
  )
}

export default Wallet
